import { render, staticRenderFns } from "./ValueComparisonLoader.vue?vue&type=template&id=aaf02894"
import script from "./ValueComparisonLoader.vue?vue&type=script&lang=js"
export * from "./ValueComparisonLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports